<template>
    <div class="dt-wrap mb-4">
        <div class="dt-header" v-if="options.board.label" data-aos="fade-in" data-aos-duration="1500">
            <h2 class="title-1">{{ options.board.label }}</h2>


            <template v-if="vw">
                <ViewWrapperToggle 
                        @wrapperToggleUpdate="wrapperToggleUpdate"
                    />
            </template>
        </div>
    </div>

<!--     <pre>-->
<!--     this.options.board: {{ this.options.board.post }}-->
<!--     </pre>-->

    <div class="boards" v-if="options.board.board_data">
        <template v-for="column in options.board.board_data">
            <div class="board">
                <template v-if="options.board.status_badge_header">
                    <div class="Badge Badge_status " :class="column.column_badge_color ? 'Badge--' + column.column_badge_color : ''" v-bind:data-color="column.column_badge_color">
                        <span class="caption-uppercase">{{ column.column_label }}</span>
                    </div>
                </template>
                <template v-else>
                    <h3>{{ column.column_label }}</h3>
                </template>

                <CardComponent
                    :options="options"
                    :rows="column.rows"
                     />
            </div>
        </template>
    </div>
</template>
<script>
import { wrapperToggleUpdate } from '@vueapp/lib/common'
import CardComponent from '@vueapp/components/CardComponent.vue'
import ViewWrapperToggle from '@vueapp/components/view-wrappers/ViewWrapperToggle.vue'
export default {
    name: 'BoardComponent',
    components: {
        CardComponent,
        ViewWrapperToggle
    },
    props: {
        postSlug: String,
        postId: String,
        options: {
            type: Object,
            required: true,
            default: {
                board: {
                    label: '',
                    board_data: {},
                    database_data: {},
                    post: {},
                    status_badge_header: false
                },
                body_class: '',
                post: {}
            }
        }
    },

    created() {
        this.wrapperToggleUpdate = wrapperToggleUpdate
    },

    computed: {
        vw() {
            return this.wrapperView
        }
    },

    inject: {
        wrapperView: {
            from: 'wrapperView',
            default: false
        }
    }
}
</script>